// src/App.jsx
import React from 'react';
import Dashboard from './pages/Dashboard/Dashboard';

export default function App() {
  return <Dashboard />;
}
